module.exports = __webpack_public_path__ + "img/eg.34937dd.svg";